import {decreasing as _decreasing} from '@total-order/primitive';

const decreasing = (a, b) => _decreasing(a, b);
export default decreasing;
